import cqrsApiService from "../../shared/services/cqrsApiService.js";

export default {
  fetchByDate(projectId, refDate, includeDeleted, vm) {
    return new Promise((resolve, reject) => {
      cqrsApiService.Get("Drilling/StagingDailyReports/FindByDate", { params : { projectId, refDate, includeDeleted } }, vm).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  findById(id, vm) {
    return new Promise((resolve, reject) => {
      cqrsApiService.Get("Drilling/StagingDailyReports/findById", { params : { id } }, vm).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  findUnmapped(projectId, vm) {
    return new Promise((resolve, reject) => {
      cqrsApiService.Get("Drilling/StagingDailyReports/findUnmapped", { params : { projectId } }, vm).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  map(item, vm) {
    return new Promise((resolve, reject) => {
      cqrsApiService.Post("Drilling/StagingDailyReports/map", item, vm).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  save(item, vm) {
    const url = item.stagingDailyReportId !== null && item.stagingDailyReportId > 0
      ? "Drilling/StagingDailyReports/Edit" 
      : "Drilling/StagingDailyReports/Create";
    return new Promise((resolve, reject) => {
      cqrsApiService.Post(url, { stagingDailyReport: item }, vm).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  delete(id, vm) {
    return new Promise((resolve, reject) => {
      cqrsApiService.Post("Drilling/StagingDailyReports/Delete", { id }, vm).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  restore(id, vm) {
    return new Promise((resolve, reject) => {
      cqrsApiService.Post("Drilling/StagingDailyReports/Restore", { id }, vm).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  deleteBatch(ids, vm) {
    return new Promise((resolve, reject) => {
      cqrsApiService.Post("Drilling/StagingDailyReports/DeleteBatch", { ids }, vm).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  getNonImportedDates(projectId, vm) {
    return new Promise((resolve, reject) => {
      cqrsApiService.Get("Drilling/StagingDailyReports/GetNonImportedDates", { params : { projectId } }, vm).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  getLatestImportedDate(projectId, vm) {
    return new Promise((resolve, reject) => {
      cqrsApiService.Get("Drilling/StagingDailyReports/GetLatestImportedDate", { params : { projectId } }, vm).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  importBatch(ids, vm) {
    return new Promise((resolve, reject) => {
      cqrsApiService.Post("Drilling/StagingDailyReports/ImportBatch", { ids }, vm).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  cancelImportBatch(ids, vm) {
    return new Promise((resolve, reject) => {
      cqrsApiService.Post("Drilling/StagingDailyReports/CancelImportBatch", { ids }, vm).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  fetchEmployeesTimesheets(projectId, refDate, includeDeleted, vm) {
    return new Promise((resolve, reject) => {
      cqrsApiService.Get("Drilling/StagingDailyReports/GetEmployeesTimesheets", { params : { projectId, refDate, includeDeleted } }, vm).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  }
}